export default {
  menus: "",
  selectedMenu: null,
  error: false,
  errorMessage: '',
  personalBankingMenus: [],
}